import { heading } from "./heading";
import { skills } from "./skills";
import { craft } from "./craft";
import { qualities } from "./qualities";
import { languages } from "./languages";
import { jobs } from "./jobs";
import { studies } from "./studies";
import { courses } from "./courses";
import { contact } from "./contact";
import { links } from "./links";
import { meta } from "./meta";

const data = {
  meta,
  heading,
  cv: {
    display: "Download Resume",
    url: "resumes/en_resume.pdf",
    filename: "srikar_sunchu_resume.pdf",
  },
  skills: {
    title: "Expertise",
    skills: skills,
  },
  craft: {
    title: "Craft",
    skills: craft,
  },
  qualities: {
    title: "Soft Skills",
    qualities: qualities,
  },
  languages: {
    title: "Languages",
    languages: languages,
  },
  jobs: {
    title: "Experience",
    jobs: jobs,
  },
  studies: {
    title: "Education",
    courses: studies,
  },
  courses: {
    title: "Courses",
    courses: courses,
  },
  contact,
  links,
};

export default data;
